import { getBorderToken, getTableToken } from "../fundations/palette/colorTokens";
export const DataGrid = {
    MuiDataGrid: {
        defaultProps: {
            density: "standard"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    /**
                 * Color overrides for v6 of @mui/x-data-grid-pro. The `--DataGrid-containerBackground` and
                 * `--DataGrid-rowBorderColor` were added in v7
                 */ "& .MuiDataGrid-pinnedColumnHeaders": {
                        background: getTableToken("tableBackground", theme)
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        background: getTableToken("tableBackground", theme)
                    },
                    /**
                 * Color overrides for v7 of @mui/x-data-grid-pro.
                 * Overrides the default colors of the DataGrid component as the theme customization is
                 * not quite as straightforward as with the other components. The docs recommend using
                 * `mixins` to achieve this, however, the `mixins` types are not updated with the theme augmentation
                 * type import. Furthermore, only `containerBackground` and `pinnedBackground` are available in the mixin.
                 */ "--DataGrid-containerBackground": getTableToken("tableBackground", theme),
                    "--DataGrid-rowBorderColor": getBorderToken("border200", theme)
                }),
            columnHeaderTitle: ({ theme })=>({
                    color: theme.palette.text.textPrimary,
                    fontSize: theme.typography.textSm.fontSize,
                    fontFamily: theme.typography.textSm.fontFamily,
                    fontFeatureSettings: theme.typography.textSm.fontFeatureSettings,
                    fontWeight: 500
                }),
            cell: ({ theme })=>({
                    color: theme.palette.text.textPrimary,
                    fontSize: theme.typography.textSm.fontSize,
                    fontFamily: theme.typography.textSm.fontFamily,
                    fontFeatureSettings: theme.typography.textSm.fontFeatureSettings,
                    fontWeight: 400
                })
        }
    }
};

//# sourceMappingURL=DataGrid.js.map